<template>
  <div class="page page-feedback" v-if="showPage">
    <!-- <navigation :showBack="false">反馈与建议</navigation> -->
    <img
      src="./images/banner@2x.png"
      width="100%"
    >

    <div class="feedback-main">
      <div class="tpis">
        您可在下方留下真实联系信息，我们将在第一时间回电，为您解决问题。
      </div>
      <form ref="form">
        <div class="feedback-section feedback-payee">
          <div class="payee-content">
            <div class="feedback-section feedback-voucher">
              <div class="voucher-title">
                用户姓名
              </div>
              <div class="voucher-content">
                <div class="form-item">
                  <nd-input
                    name="name"
                    v-model="form.name"
                    maxLength="10"
                    label=""
                    placeholder="请输入您的姓名"
                  ></nd-input>
                </div>
              </div>
            </div>

            <div class="feedback-section feedback-voucher">
              <div class="voucher-title">
                联系电话
              </div>
              <div class="voucher-content">
                <div class="form-item">
                  <nd-input
                    name="mobile"
                    v-model="form.mobile"
                    maxLength="11"
                    type="pure-number"
                    label=""
                    placeholder="请输入您的手机号码"
                  ></nd-input>
                </div>
              </div>
            </div>

            <div class="feedback-section feedback-voucher">
              <div class="voucher-title">
                身份证后4位
              </div>
              <div class="voucher-content">
                <div class="form-item">
                  <nd-input
                    name="idCard"
                    v-model="form.idCard"
                    maxLength="4"
                    label=""
                    placeholder="请输入您本人的身份证件后4位"
                  ></nd-input>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="feedback-section feedback-voucher">
          <div class="voucher-title">
            反馈与建议
          </div>
          <div class="voucher-content">
            <div class="form-item">
              <nd-input
                name="content"
                type="textarea"
                class="textarea"
                v-model="form.content"
                label=""
                :rows="5"
                :autoSize="false"
                maxLength="200"
                placeholder="请输入您需要反馈的内容"
              ></nd-input>
            </div>
          </div>
        </div>

        <div class="feedback-section feedback-voucher">
          <div class="voucher-title no-title-required">
            问题截图（选填）
          </div>
          <div class="voucher-content">
            <div class="form-item">
              <nd-upload
                name="imageUrls"
                :images.sync="form.imageUrls"
                fileType="FEEDBACK"
                :limit="5"
              ></nd-upload>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="feedback-bottom">
      <nd-button @click="handleApply" :isDisabled="isDisabled" :loading="pending">提交反馈</nd-button>
    </div>

  </div>
</template>

<script>
import validate from '@/components/nd-validate/validateNew'
import { isEmojiCharacter } from '@/assets/utils'
import { mapActions } from 'vuex'

export default {
  mixins: [validate],
  data () {
    return {
      step: 1,
      isDisabled: true,
      pending: false,
      showPage: false,
      form: {
        name: '',
        mobile: '',
        idCard: '',
        content: '',
        imageUrls: [] 
      },
      rules: {
        name: [
          { require: true, message: '姓名不能为空', trigger: 'blur' },
          {
            handler: (input) =>
              /^[\u4e00-\u9fa5]{2,10}$/.test(input) && !isEmojiCharacter(input),
            message: '请输入正确姓名',
            trigger: 'blur'
          }
        ],
        mobile: [
          { require: true, message: '手机号码不能为空', trigger: 'change' },
          {
            handler: (input) => /^1\d{10}$/.test(input),
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        idCard: [
          { require: true, message: '身份证后4位不能为空', trigger: 'change' },
          {
            handler: (input) => /^\d{4}$/.test(input),
            message: '格式错误，请重新输入',
            trigger: 'blur'
          }
        ],
       
        content: [
          { require: true, message: '反馈内容不能为空', trigger: 'blur' },
          {
            handler: (input) => input.length >= 5,
            message: '反馈内容至少输入 5 个字',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    if (localStorage.getItem('feedbackDate') === this.formatDate(new Date())) {
      this.$router.push('/feedback/result')
    } else {
      this.showPage = true
    }
    this.$bus.$emit('ready')
  },
  mounted () {
    const ref = this.$refs.form
    if (ref) {
      this.validator(ref, this.rules)
    }
  },
  methods: {
    ...mapActions('user', ['customerFeedback']),

    async handleApply () {
      const ref = this.$refs.form
      if (ref) {
        const res = this.validate(ref, this.rules)
        if (!res) return
        this.pending = true
        const { success } = await this.customerFeedback(this.form)
        this.pending = false
        if (success) {
          localStorage.setItem('feedbackDate', this.formatDate(new Date()))
          this.$router.push('/feedback/result')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page-feedback {
  background-color: #fff;
  padding-bottom: 270px;
  .tpis {
    font-family: PingFangSC, PingFang SC;
    font-size: 28px;
  }
  .feedback-main {
    padding: 40px;
    .feedback-section {
      border-radius: 20px;
      margin-top: 50px;
      .voucher-title {
        font-weight: 500;
        font-size: 28px;
        color: #666;
        font-family: PingFangSC, PingFang SC;
        &::before {
          content: "*";
          color: #ff5223;
        }
        &.no-title-required::before {
          content: "";
        }
      }
      .nd-input {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #eee;
      }
      .form-item {
        padding-top: 8px;
        .textarea {
          padding: 12px;
          border-bottom: none;
          height: 220px !important;
          background: #f7f7f7;
          border-radius: 16px;
          textarea {
            height: 220px !important;
          }
        }
      }
      &.section-progress {
        padding: 70px 60px 37px;
      }
      &.feedback-info {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #333333;
        padding: 57px 0 66px;
        .info-title {
          font-size: 24px;
        }
        .info-amount {
          font-family: DIN-Medium, DIN;
          font-size: 48px;
          font-weight: 500;
          margin-top: 7px;
          span {
            font-size: 72px;
          }
        }
      }
    }

    .feedback-desc {
      margin-top: 30px;
      .desc-title {
        font-size: 30px;
        color: #333333;
        font-weight: bold;
      }
      .desc-content {
        font-size: 24px;
        color: #999999;
        margin-top: 8px;
        line-height: 33px;
      }
    }
  }
  .feedback-bottom {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    width: 750px;
    left: auto;
    right: auto;
    padding: 28px 50px 58px;
    .bottom-btn {
      width: 100%;
      background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
      line-height: 94px;
      text-align: center;
      border-radius: 47px;
      color: #fff;
      font-size: 32px;
    }
  }
}
</style>